import $ from 'jquery';
import {is_string} from '../../Helpers/js/index';
import LP from './0-lp';
import UI from './0-ui';

// ---------------------
// LAMAPOLL UI
// ---------------------
LP.UI = LP.UI || {
  // --------------
  // Init Shortcuts
  // --------------
  initButtonMenu: function (params) {
    LP.UI.ButtonMenu.init(params);
  },
  initButtons: function (selector) {
    UI.setupButtons(selector);
  },

  // --------------
  // Message Boxes
  // --------------

  //confirmModal with green submit button
  confirm: function (item, onConfirm, onNotConfirm) {
    var text = '';
    if (is_string(item)) {
      text = item;
    } else if ($('.confirmation', item).length > 0) {
      text = $('.confirmation', item).html();
    } else {
      text = item.html();
    }

    UI.showMsgBox(text, UI.MsgBox.mYESNO, onConfirm, onNotConfirm);
    return false;
  },

  //confirmModal with red submit button
  warnConfirm: function (item, onConfirm, onNotConfirm) {
    var text = '';
    if (is_string(item)) {
      text = item;
    } else if ($('.confirmation', item).length > 0) {
      text = $('.confirmation', item).html();
    } else {
      text = item.html();
    }
    UI.showMsgBox(text, UI.MsgBox.wYESNO, onConfirm, onNotConfirm);
    return false;
  },

  // --------------
  // Text Editor Dialog
  // --------------
  openTextEditor: function (href, params, editElement, dialogName, dialogTitle, useContent, showLarge, afterSubmit, beforeSubmit) {
    var dialogWidth, dialogHeight;

    if (showLarge) {
      dialogWidth = 750;
      dialogHeight = 450;
    } else {
      dialogWidth = 900;
      dialogHeight = 550;
    }
    LP.Dialog.open({
      ajax: href,
      request: params,
      element: editElement,
      useContent: useContent,
      name: dialogName,
      title: dialogTitle,
      width: dialogWidth,
      height: dialogHeight,
      sizeable: true,
      onLoad: LP.Dialog.TextEditor.onLoad,
      beforeSubmit: LP.Dialog.TextEditor.beforeSubmit,
      afterSubmit: afterSubmit,
      beforeEditorSubmit: beforeSubmit,
      onClose: LP.Dialog.TextEditor.onClose,
    });
  },
};

// Link-based buttons (role="button") must also trigger on Space like native buttons; skip when React already handled the key
$(document).on('keydown', 'a[role="button"]', function (e) {
  if (e.key === ' ' && !e.isDefaultPrevented()) {
    e.preventDefault();
    this.click();
  }
});
